import { createReducer, ActionType } from 'typesafe-actions';
import {
  getSoftwareVersionsAC,
  setSelectedPrinter,
  setSerialGkNumberForSoftwareVersion,
  toggleSwPopUp,
} from 'actions/softwareVersionPopoverActions';
import { createSelector } from 'reselect';
import { Store } from 'store/storeTypes';
import { ISystemReport } from 'models/SystemAnalysisData';

export interface SoftwareVersionPopoverState {
  isOpen: boolean;
  isLoading: boolean;
  isSoftWareVersionError?: string;
  serialNumber: string;
  appName: string;
  componentVersions: [];
  globalSoftwareLastUpdate: string;
  globalSoftwareVersion: string;
  systemSerialGk: string;
  selectedPrinter: ISystemReport;
}

const INIT_STATE: SoftwareVersionPopoverState = {
  isOpen: false,
  isLoading: true,
  isSoftWareVersionError: '',
  serialNumber: undefined,
  appName: '',
  componentVersions: [],
  globalSoftwareLastUpdate: '',
  globalSoftwareVersion: '',
  systemSerialGk: undefined,
  selectedPrinter: undefined,
};

const reducer = createReducer(INIT_STATE)
  .handleAction(setSelectedPrinter, (state, action) => {
    return { ...state, selectedPrinter: action.payload.printer };
  })
  .handleAction(setSerialGkNumberForSoftwareVersion, (state, action) => {
    return {
      ...state,
      systemSerialGk: action.payload.systemSerialGk,
    };
  })
  .handleAction(toggleSwPopUp, (state, action) => {
    return {
      ...state,
      isOpen: action.payload.isOpen,
    };
  })
  .handleAction(getSoftwareVersionsAC.request, (state, action) => {
    return {
      ...state,
      isLoading: true,
      isSoftWareVersionError: '',
      appName: '',
      componentVersions: [],
      globalSoftwareLastUpdate: '',
      globalSoftwareVersion: '',
    };
  })
  .handleAction(getSoftwareVersionsAC.failure, (state, error) => {
    return {
      ...state,
      isLoading: false,
      isSoftWareVersionError: error,
    };
  })
  .handleAction(getSoftwareVersionsAC.success, (state, action) => {
    return {
      ...state,
      isLoading: false,
      isSoftWareVersionError: '',
      appName: action.payload.appName,
      componentVersions: action.payload.componentVersions,
      globalSoftwareLastUpdate: action.payload.globalSoftwareLastUpdate,
      globalSoftwareVersion: action.payload.globalSoftwareVersion,
    };
  });
export default reducer;

// --- Selectors ---
export const softwareVersionPopoverSelector = (state: Store): SoftwareVersionPopoverState => {
  return state.softwareVersion;
};
export const appNameSelector = createSelector([softwareVersionPopoverSelector], softwareVersion => {
  return softwareVersion['appName'];
});
export const componentVersionsSelector = createSelector(
  [softwareVersionPopoverSelector],
  softwareVersion => {
    return softwareVersion['componentVersions'];
  }
);
export const globalSoftwareLastUpdateSelector = createSelector(
  [softwareVersionPopoverSelector],
  softwareVersion => {
    return softwareVersion['globalSoftwareLastUpdate'];
  }
);
export const globalSoftwareVersionSelector = createSelector(
  [softwareVersionPopoverSelector],
  softwareVersion => {
    return softwareVersion['globalSoftwareVersion'];
  }
);
export const isSoftwareVersionPopoverOpenSelector = createSelector(
  [softwareVersionPopoverSelector],
  softwareVersion => {
    return softwareVersion['isOpen'];
  }
);

export const isSoftwareVersionPopoverLoadingSelector = createSelector(
  [softwareVersionPopoverSelector],
  softwareVersion => {
    return softwareVersion['isLoading'];
  }
);
export const selectedSerialGkNumberForSoftwareVersionSelector = createSelector(
  [softwareVersionPopoverSelector],
  softwareVersion => {
    return softwareVersion['systemSerialGk'];
  }
);
export const selectedPrinterSelector = createSelector(
  [softwareVersionPopoverSelector],
  softwareVersion => {
    return softwareVersion['selectedPrinter'];
  }
);
